import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PRODUCTION_BASE = 'https://nauticabrusa.ch';

const LANG_SUFFIXES = {
  it: '',
  de: '?lang=de',
  fr: '?lang=fr',
  en: '?lang=en',
};

// OG locale map
const OG_LOCALE = {
  it: 'it_CH',
  de: 'de_CH',
  fr: 'fr_CH',
  en: 'en_GB',
};

// ─── SEO metadata per pagina e per lingua ────────────────────────────────────
const SEO_META = {
  '/': {
    it: { title: 'Cantiere Nautico Brusa | Locarno, Ticino | Lago Maggiore', description: 'Dal 1977, il punto di riferimento per la nautica sul Lago Maggiore. Vendita barche nuove e usate, rimessaggio, manutenzione e assistenza a Locarno, Ticino.' },
    de: { title: 'Bootswerft Brusa | Locarno, Tessin | Lago Maggiore', description: 'Seit 1977 Ihr Ansprechpartner für Nautik am Lago Maggiore. Bootsverkauf, Winterlager, Wartung und Reparatur in Locarno, Tessin.' },
    fr: { title: 'Chantier Naval Brusa | Locarno, Tessin | Lac Majeur', description: 'Depuis 1977, votre référence nautique sur le Lac Majeur. Vente de bateaux, hivernage, entretien et services nautiques à Locarno, Tessin.' },
    en: { title: 'Cantiere Nautico Brusa | Locarno, Ticino | Lake Maggiore', description: 'Since 1977, your nautical reference on Lake Maggiore. Boat sales, winter storage, maintenance and services in Locarno, Ticino, Switzerland.' },
  },
  '/boats': {
    it: { title: 'Barche in Vendita a Locarno | Cantiere Nautico Brusa Ticino', description: 'Scopri il catalogo di barche nuove e usate sul Lago Maggiore. Vendita imbarcazioni a Locarno e in tutto il Ticino. Cantiere Nautico Brusa dal 1977.' },
    de: { title: 'Boote kaufen in Locarno | Bootswerft Brusa Tessin', description: 'Entdecken Sie neue und gebrauchte Boote am Lago Maggiore. Bootsverkauf in Locarno und im ganzen Tessin. Bootswerft Brusa seit 1977.' },
    fr: { title: 'Bateaux à Vendre à Locarno | Chantier Naval Brusa Tessin', description: "Découvrez notre catalogue de bateaux neufs et d'occasion sur le Lac Majeur. Vente à Locarno et dans tout le Tessin. Chantier Naval Brusa depuis 1977." },
    en: { title: 'Boats for Sale in Locarno | Cantiere Nautico Brusa Ticino', description: 'Browse new and used boats on Lake Maggiore. Boat sales in Locarno and throughout Ticino, Switzerland. Cantiere Nautico Brusa since 1977.' },
  },
  '/services': {
    it: { title: 'Servizi Nautici a Locarno | Rimessaggio e Manutenzione | Cantiere Brusa', description: 'Rimessaggio invernale, manutenzione motori, carena e assistenza completa per la tua barca a Locarno sul Lago Maggiore. Cantiere Nautico Brusa Ticino.' },
    de: { title: 'Nautische Dienstleistungen Locarno | Winterlager & Wartung | Werft Brusa', description: 'Winterlager, Motorwartung, Antifouling und kompletter Service für Ihr Boot in Locarno am Lago Maggiore. Bootswerft Brusa Tessin seit 1977.' },
    fr: { title: 'Services Nautiques à Locarno | Hivernage & Entretien | Chantier Brusa', description: 'Hivernage, entretien moteur, carénage et services complets pour votre bateau à Locarno sur le Lac Majeur. Chantier Naval Brusa Tessin.' },
    en: { title: 'Nautical Services Locarno | Winter Storage & Maintenance | Cantiere Brusa', description: 'Winter storage, engine maintenance, antifouling and full boat services in Locarno on Lake Maggiore. Cantiere Nautico Brusa Ticino, Switzerland.' },
  },
  '/gallery': {
    it: { title: 'Galleria Foto | Cantiere Nautico Brusa Locarno, Ticino', description: 'Guarda le nostre barche e il cantiere nautico in immagini. Cantiere Nautico Brusa a Locarno sul Lago Maggiore, Ticino.' },
    de: { title: 'Fotogalerie | Bootswerft Brusa Locarno, Tessin', description: 'Entdecken Sie unsere Boote und die Bootswerft in Bildern. Bootswerft Brusa in Locarno am Lago Maggiore, Tessin.' },
    fr: { title: 'Galerie Photos | Chantier Naval Brusa Locarno, Tessin', description: 'Découvrez nos bateaux et le chantier naval en photos. Chantier Naval Brusa à Locarno sur le Lac Majeur, Tessin.' },
    en: { title: 'Photo Gallery | Cantiere Nautico Brusa Locarno, Ticino', description: 'See our boats and the boatyard in pictures. Cantiere Nautico Brusa in Locarno on Lake Maggiore, Ticino, Switzerland.' },
  },
  '/events': {
    it: { title: 'Eventi Nautici in Ticino | Locarno Lago Maggiore | Cantiere Brusa', description: 'Scopri i prossimi eventi nautici in Ticino e sul Lago Maggiore. Fiere, manifestazioni e appuntamenti con Cantiere Nautico Brusa a Locarno.' },
    de: { title: 'Nautikmessen im Tessin | Locarno Lago Maggiore | Werft Brusa', description: 'Entdecken Sie die nächsten Nautikveranstaltungen im Tessin und am Lago Maggiore. Messen und Events mit Bootswerft Brusa in Locarno.' },
    fr: { title: 'Événements Nautiques au Tessin | Locarno Lac Majeur | Chantier Brusa', description: 'Découvrez les prochains événements nautiques au Tessin et sur le Lac Majeur. Salons et manifestations avec Chantier Naval Brusa à Locarno.' },
    en: { title: 'Nautical Events in Ticino | Locarno Lake Maggiore | Cantiere Brusa', description: 'Discover upcoming nautical events in Ticino and on Lake Maggiore. Fairs and shows with Cantiere Nautico Brusa in Locarno, Switzerland.' },
  },
  '/contact': {
    it: { title: 'Contatti | Cantiere Nautico Brusa Locarno, Ticino', description: 'Contatta Cantiere Nautico Brusa a Locarno. Siamo sul Lago Maggiore in Ticino. Tel, email e come raggiungerci.' },
    de: { title: 'Kontakt | Bootswerft Brusa Locarno, Tessin', description: 'Kontaktieren Sie Bootswerft Brusa in Locarno. Wir befinden uns am Lago Maggiore im Tessin. Tel, E-Mail und Anfahrtsbeschreibung.' },
    fr: { title: 'Contact | Chantier Naval Brusa Locarno, Tessin', description: 'Contactez Chantier Naval Brusa à Locarno. Nous sommes sur le Lac Majeur au Tessin. Tél, email et comment nous rejoindre.' },
    en: { title: 'Contact | Cantiere Nautico Brusa Locarno, Ticino', description: 'Contact Cantiere Nautico Brusa in Locarno. Located on Lake Maggiore in Ticino, Switzerland. Phone, email and directions.' },
  },
  '/quote': {
    it: { title: 'Richiedi un Preventivo | Cantiere Nautico Brusa Locarno, Ticino', description: 'Richiedi un preventivo gratuito per acquisto barca o servizi nautici a Locarno, Ticino. Cantiere Nautico Brusa sul Lago Maggiore dal 1977.' },
    de: { title: 'Angebot anfordern | Bootswerft Brusa Locarno, Tessin', description: 'Kostenloses Angebot für Bootskauf oder nautische Dienstleistungen in Locarno, Tessin. Bootswerft Brusa am Lago Maggiore seit 1977.' },
    fr: { title: 'Demander un Devis | Chantier Naval Brusa Locarno, Tessin', description: "Demandez un devis gratuit pour achat de bateau ou services nautiques à Locarno, Tessin. Chantier Naval Brusa sur le Lac Majeur depuis 1977." },
    en: { title: 'Request a Quote | Cantiere Nautico Brusa Locarno, Ticino', description: 'Request a free quote for boat purchase or nautical services in Locarno, Ticino. Cantiere Nautico Brusa on Lake Maggiore since 1977.' },
  },
  '/partners': {
    it: { title: 'I Nostri Partner | Cantiere Nautico Brusa Locarno, Ticino', description: 'Scopri i marchi nautici partner di Cantiere Nautico Brusa a Locarno. Collaboriamo con i migliori brand della nautica sul Lago Maggiore.' },
    de: { title: 'Unsere Partner | Bootswerft Brusa Locarno, Tessin', description: 'Entdecken Sie die Markenpartner der Bootswerft Brusa in Locarno. Wir arbeiten mit den besten Nautikmarken am Lago Maggiore zusammen.' },
    fr: { title: 'Nos Partenaires | Chantier Naval Brusa Locarno, Tessin', description: 'Découvrez les marques partenaires du Chantier Naval Brusa à Locarno. Nous collaborons avec les meilleures marques nautiques du Lac Majeur.' },
    en: { title: 'Our Partners | Cantiere Nautico Brusa Locarno, Ticino', description: 'Discover the brand partners of Cantiere Nautico Brusa in Locarno. We work with the best nautical brands on Lake Maggiore, Switzerland.' },
  },
};

const DEFAULT_META = {
  it: { title: 'Cantiere Nautico Brusa | Locarno, Ticino', description: 'Cantiere Nautico Brusa a Locarno sul Lago Maggiore. Vendita barche, rimessaggio e servizi nautici in Ticino dal 1977.' },
  de: { title: 'Bootswerft Brusa | Locarno, Tessin', description: 'Bootswerft Brusa in Locarno am Lago Maggiore. Bootsverkauf, Winterlager und nautische Dienstleistungen im Tessin seit 1977.' },
  fr: { title: 'Chantier Naval Brusa | Locarno, Tessin', description: 'Chantier Naval Brusa à Locarno sur le Lac Majeur. Vente de bateaux, hivernage et services nautiques au Tessin depuis 1977.' },
  en: { title: 'Cantiere Nautico Brusa | Locarno, Ticino', description: 'Cantiere Nautico Brusa in Locarno on Lake Maggiore. Boat sales, winter storage and nautical services in Ticino, Switzerland since 1977.' },
};

// ─── JSON-LD Structured Data ─────────────────────────────────────────────────
const LOCAL_BUSINESS_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': ['LocalBusiness', 'BoatDealer'],
  '@id': 'https://nauticabrusa.ch/#business',
  name: 'Cantiere Nautico Brusa',
  alternateName: ['Bootswerft Brusa', 'Chantier Naval Brusa'],
  url: 'https://nauticabrusa.ch',
  logo: 'https://nauticabrusa.ch/og-image.png',
  image: 'https://nauticabrusa.ch/og-image.png',
  telephone: '+41917921946',
  email: 'info@nauticabrusa.ch',
  foundingDate: '1977',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Via Pizzante 11',
    addressLocality: 'Riazzino',
    postalCode: '6595',
    addressRegion: 'Ticino',
    addressCountry: 'CH',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 46.1667,
    longitude: 8.7957,
  },
  hasMap: 'https://maps.google.com/?q=Via+Pizzante+11,+6595+Riazzino,+Switzerland',
  openingHoursSpecification: [
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '08:00', closes: '18:00' },
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Saturday'], opens: '08:00', closes: '12:00' },
  ],
  priceRange: '€€€',
  areaServed: [
    { '@type': 'City', name: 'Locarno' },
    { '@type': 'AdministrativeArea', name: 'Ticino' },
    { '@type': 'Country', name: 'Switzerland' },
  ],
  availableLanguage: ['Italian', 'German', 'French', 'English'],
  sameAs: ['https://www.nauticabrusa.ch'],
  description: 'Cantiere Nautico Brusa – vendita barche nuove e usate, rimessaggio, manutenzione e servizi nautici sul Lago Maggiore dal 1977. Locarno, Ticino.',
};

const PAGE_SCHEMAS = {
  '/': LOCAL_BUSINESS_SCHEMA,
  '/contact': LOCAL_BUSINESS_SCHEMA,
  '/boats': {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Barche in Vendita – Cantiere Nautico Brusa',
    description: 'Catalogo barche nuove e usate disponibili presso Cantiere Nautico Brusa a Locarno, Ticino.',
    url: 'https://nauticabrusa.ch/boats',
    provider: { '@id': 'https://nauticabrusa.ch/#business' },
  },
  '/services': {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Servizi Nautici – Cantiere Nautico Brusa',
    serviceType: ['Boat storage', 'Boat maintenance', 'Boat repair', 'Antifouling'],
    description: 'Rimessaggio invernale, manutenzione motori e servizi completi per la tua barca a Locarno, Ticino.',
    provider: { '@id': 'https://nauticabrusa.ch/#business' },
    areaServed: { '@type': 'City', name: 'Locarno' },
  },
  '/events': {
    '@context': 'https://schema.org',
    '@type': 'EventSeries',
    name: 'Eventi Nautici – Cantiere Nautico Brusa',
    description: 'Fiere ed eventi nautici in Ticino e sul Lago Maggiore.',
    organizer: { '@id': 'https://nauticabrusa.ch/#business' },
    location: { '@type': 'Place', name: 'Lago Maggiore, Ticino, Svizzera' },
  },
  '/quote': {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Richiedi Preventivo – Cantiere Nautico Brusa',
    description: 'Richiesta preventivo gratuito per acquisto barca o servizi nautici a Locarno.',
    provider: { '@id': 'https://nauticabrusa.ch/#business' },
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'CHF', description: 'Preventivo gratuito' },
  },
};

// ─── Helpers ─────────────────────────────────────────────────────────────────
const setMeta = (name, content, attr = 'name') => {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
  el.content = content;
};

const setJsonLd = (schema) => {
  let el = document.querySelector('script[type="application/ld+json"]');
  if (!el) { el = document.createElement('script'); el.type = 'application/ld+json'; document.head.appendChild(el); }
  el.textContent = JSON.stringify(schema);
};

/**
 * Injects complete SEO metadata into document.head per page + language:
 * - <title>, <meta name="description">
 * - <link rel="canonical"> (language-specific)
 * - <link rel="alternate" hreflang> (all languages)
 * - Open Graph (og:title, og:description, og:url, og:locale, og:image)
 * - Twitter Card
 * - <meta name="robots"> (noindex on preview)
 * - JSON-LD structured data (LocalBusiness / ItemList / Service / Event)
 */
const CanonicalTag = () => {
  const location = useLocation();

  useEffect(() => {
    const host = window.location.hostname;
    const isPreview = host.includes('preview.emergentagent.com') || host.includes('localhost') || host.includes('127.0.0.1');

    const params = new URLSearchParams(location.search);
    const currentLang = params.get('lang') || 'it';
    const basePath = location.pathname;

    const pageMeta = SEO_META[basePath] || DEFAULT_META;
    const meta = pageMeta[currentLang] || pageMeta['it'] || DEFAULT_META['it'];

    const langUrl = (lang) => {
      const suffix = LANG_SUFFIXES[lang] || '';
      return `${PRODUCTION_BASE}${basePath}${suffix}${location.hash}`;
    };

    // ── Title ──
    document.title = meta.title;

    // ── Meta description ──
    setMeta('description', meta.description);

    // ── Robots ──
    setMeta('robots', isPreview ? 'noindex, nofollow' : 'index, follow');

    // ── Open Graph ──
    setMeta('og:title', meta.title, 'property');
    setMeta('og:description', meta.description, 'property');
    setMeta('og:url', langUrl(currentLang), 'property');
    setMeta('og:type', 'website', 'property');
    setMeta('og:site_name', 'Cantiere Nautico Brusa', 'property');
    setMeta('og:image', 'https://nauticabrusa.ch/og-image.png', 'property');
    setMeta('og:image:width', '1200', 'property');
    setMeta('og:image:height', '1200', 'property');
    setMeta('og:locale', OG_LOCALE[currentLang] || 'it_CH', 'property');

    // ── Twitter Card ──
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', meta.title);
    setMeta('twitter:description', meta.description);
    setMeta('twitter:image', 'https://nauticabrusa.ch/og-image.png');

    // ── Canonical ──
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = langUrl(currentLang);

    // ── Hreflang alternates ──
    document.querySelectorAll('link[hreflang]').forEach((el) => el.remove());
    Object.keys(LANG_SUFFIXES).forEach((lang) => {
      const link = document.createElement('link');
      link.rel = 'alternate'; link.hreflang = lang; link.href = langUrl(lang);
      document.head.appendChild(link);
    });
    const xDefault = document.createElement('link');
    xDefault.rel = 'alternate'; xDefault.hreflang = 'x-default'; xDefault.href = langUrl('it');
    document.head.appendChild(xDefault);

    // ── JSON-LD Structured Data ──
    const schema = PAGE_SCHEMAS[basePath];
    if (schema) {
      setJsonLd(schema);
    } else {
      // Remove schema on pages without one
      const existing = document.querySelector('script[type="application/ld+json"]');
      if (existing) existing.remove();
    }
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default CanonicalTag;
